import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const inputSectionFn = /* @__PURE__ */ createRecipe('input-section', {}, [])

const inputSectionVariantMap = {
  "pointerEvents": [
    "none",
    "auto"
  ]
}

const inputSectionVariantKeys = Object.keys(inputSectionVariantMap)

export const inputSection = /* @__PURE__ */ Object.assign(memo(inputSectionFn.recipeFn), {
  __recipe__: true,
  __name__: 'inputSection',
  __getCompoundVariantCss__: inputSectionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: inputSectionVariantKeys,
  variantMap: inputSectionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, inputSectionVariantKeys)
  },
  getVariantProps: inputSectionFn.getVariantProps,
})